import { render, staticRenderFns } from "./SubscribeSelection.vue?vue&type=template&id=23008768&"
import script from "./SubscribeSelection.vue?vue&type=script&lang=js&"
export * from "./SubscribeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports